import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import ContractsList from './contracts-content/ContractsList'

class Contracts extends Component {
  render() {
    return (
      <div>
        <ContractsList vacancyId={this.props.vacancyId} />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  contracts: state.vacancyPage.contracts,
})
const mapDispatchToProps = dispatch => ({
})
export default compose(connect(mapStateToProps, mapDispatchToProps))(Contracts)
